import { FC } from "react";
import EasyAccessLink from "./SubComponet/EasyAccessLink";
import { EasyAccessProps, EasyAccessItem } from "./types";
import { sortObjectByKeySuffix } from "@repo/shared-utils/common-utils";

const EasyAccess: FC<EasyAccessProps> = ({ content }) => {
  const { componentTitle, quickLinks } = content;
  const orderedItems = sortObjectByKeySuffix(
    quickLinks[0] || {},
    "item",
  ) as EasyAccessItem[];
  return (
    <div className="cursor-pointer px-[16px] py-[12px]">
      <h3 className="pb-[10px] text-[18px] font-[500] md:text-[20px]">
        {componentTitle}
      </h3>
      <div className="overflow-hidden rounded-[4px] border border-gray-200">
        {orderedItems.map((item) => (
          <EasyAccessLink
            redirectionUrl={item.redirectionUrl}
            label={item.label}
            key={item.id}
            sectionTitle={componentTitle}
          />
        ))}
      </div>
    </div>
  );
};

export default EasyAccess;
